import { Text, Flex } from '@/_components';
import type { FC } from 'react';
import type { QuestionProvidedElsewhereProps } from './QuestionProvidedElsewhere.types';

export const QuestionProvidedElsewhere: FC<
  QuestionProvidedElsewhereProps
> = () => {
  return (
    <Flex isColumn={true}>
      <Text type="small">You provided this elsewhere.</Text>
    </Flex>
  );
};
